import { type CarrierDef } from '../common.js'
import { accountNumber, password, username, userPassMap } from '../internal.js'

const credentialTypes = [
  username,
  password,
  accountNumber,
  'access-token',
  'access-license-number',
  'client-id', // only used in tyche - probably need form config for these
  'client-secret', // only used in tyche - probably need form config for these
  'refresh-token', // only used in tyche - probably need form config for these
] as const
const locationCredentialTypes = ['location-account-number'] as const

export type upgfCredType =
  | (typeof credentialTypes)[number]
  | (typeof locationCredentialTypes)[number]

export const upgf: CarrierDef<upgfCredType> = {
  name: 'TForce Freight',
  scac: 'upgf',
  ltlServices: [
    { id: 'standard', name: 'Standard' },
    { id: 'volume', name: 'Volume' },
  ],
  parcelServices: [
    { id: 'ground', name: 'UPS Ground' },
    { id: 'next_day', name: 'UPS Next Day Air' },
    { id: 'next_day_saver', name: 'UPS Next Day Air Saver' },
    { id: 'next_day_early', name: 'UPS Next Day Air Early' },
    { id: 'second_day', name: 'UPS 2nd Day Air' },
    { id: 'second_day_am', name: 'UPS 2nd Day Air A.M.' },
    { id: 'three_day_select', name: 'UPS 3 Day Select' },
  ],
  credentialTypes,
  locationCredentialTypes,
  legacyCredMap: [
    ...userPassMap,
    ['access-license-number', 'apiKey'],
    ['account-number', 'accountNumber'], // TODO - this may or may not be used.  I always get confused with iris's upgf/upss setup
    ['location-account-number', 'ref1'],
  ],
  engineLayers: [
    'provisioning',
    'rating',
    'bol',
    'pickup',
    'cancel',
    'profinder',
    'tracking',
  ],
  credentialConfig: {
    'location-account-number': { customerIdentifier: true },
  },
}
